// src/RegionalDashboard.js
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './RegionalDashboard.css';
import delBuildings from './delBuildings.json';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import API_BASE_URL from './config/api';


import { FaChevronDown } from 'react-icons/fa';

import Navbar from './Components/Navbar/Navbar';
import Header from './Components/Header/BlueHeader';
import SinglePill from './Components/Pills/SinglePill';
import BuildingsTable from './Components/BuildingsTable/BuildingsTable';
import SearchBar from './Components/SearchBar/SearchBar';
import Joyride from 'react-joyride';
import SystemMultiSelect from './Components/SystemMultiSelect/SystemMultiSelect';
import Footer from './Components/Footer/Footer';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import { FaBuilding, FaCheckSquare, FaUsers } from 'react-icons/fa';

// Helper to detect video URLs
function isVideoUrl(url) {
  const videoExts = [".mp4", ".mov", ".webm", ".ogg", ".m4v"];
  return videoExts.some((ext) => url.toLowerCase().endsWith(ext));
}

function RegionalDashboard() {

  const [showFirstTimeModal, setShowFirstTimeModal] = useState(false);

  // For the building typeahead in the invite modal
const [filteredBuildings, setFilteredBuildings] = useState([]);
const [showDropdown, setShowDropdown] = useState(false);

const [selectedBuilding, setSelectedBuilding] = useState(null);


  // Loading spinner for the "Send Invitation" button
  const [inviteLoading, setInviteLoading] = useState(false);

  // 1) Auth & user
  const token = localStorage.getItem('managerToken');
  const userStr = localStorage.getItem('managerUser') || "";
  let userObj = null;
  let buildingCount = 0;
  if (userStr) {
    try {
      userObj = JSON.parse(userStr);
      console.log("Current user data:", userObj);
      if (userObj.buildings) {
        buildingCount = userObj.buildings.length;
      }
    } catch (err) {
      console.error("Error parsing user data:", err);
    }
  }

  const [fetchedUser, setFetchedUser] = useState(null);

  // 2) Stats: number of buildings, completed maintenances
  const [stats, setStats] = useState({
    numBuildings: buildingCount,
    completedMaintenances: 0,
  });

  // Joyride / Tour
  const hasSeenRegionalTour = localStorage.getItem('hasSeenRegionalTour') === 'true';
  const [runTour, setRunTour] = useState(!hasSeenRegionalTour);

  // 3) Buildings data (for table)
  const [buildingsData, setBuildingsData] = useState([]);

  // 4) Loading states
  const [isLoading, setIsLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(false);

  // 5) Table states
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // 6) Slideshow
  const [showModal, setShowModal] = useState(false);
  const [carouselPhotos, setCarouselPhotos] = useState([]);
  const [carouselIndex, setCarouselIndex] = useState(0);

  // 7) Filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSystems, setSelectedSystems] = useState([]);

  // 8) Invite Manager modal
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteName, setInviteName] = useState('');
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteBuilding, setInviteBuilding] = useState('');

  // 9) Success alert for invitation
  const [showInviteSuccess, setShowInviteSuccess] = useState(false);

  // Joyride steps
  const steps = [
    {
      target: 'body',
      content: '👋 Welcome to the Hudson Regional Manager Dashboard! This quick tour will show you everything you need to manage your properties effectively.',
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '[data-tour="navbar-info"]',
      content: 'This is your management company and District Manager Portal. Easily navigate and oversee your portfolio here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="pills-stats"]',
      content: '📊 Quickly check essential stats, including the number of buildings you oversee and completed maintenance inspections.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="team-management-pill"]',
      content: '👥 Invite property managers to your team in seconds and manage your growing network of buildings.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="search-filter"]',
      content: '🔍 Use this powerful search and filter tool to quickly find buildings or managers and filter by HVAC system type.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="buildings-table"]',
      content: '🏢 Here\'s a detailed overview of all your buildings, their inspection statuses, and other critical details. You can easily sort and navigate through your properties.',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: '🎉 You\'re all set! Enjoy using the Hudson Regional Dashboard to keep your properties running smoothly.',
      placement: 'center',
      disableBeacon: true,
    },
  ];


  const handleBuildingChange = (e) => {
    const val = e.target.value;
    setInviteBuilding(val);

    // Clear any previously selected building if user changes text
    setSelectedBuilding(null);

    if (!val) {
      setFilteredBuildings([]);
      setShowDropdown(false);
      return;
    }
    const lowerVal = val.toLowerCase();
    const matches = delBuildings.filter(
      (b) =>
        (b.name && b.name.toLowerCase().includes(lowerVal)) ||
        (b.address && b.address.toLowerCase().includes(lowerVal))
    );
    setFilteredBuildings(matches);
    setShowDropdown(matches.length > 0);
  };


    // Toggle the dropdown manually (chevron click)
    const handleToggleDropdown = () => {
      // If it's currently open, just close it
      if (showDropdown) {
        setShowDropdown(false);
        return;
      }
      // If closed, open it:
      // - If there's text typed, show filtered
      // - If there's no text typed, show the entire list
      if (inviteBuilding.trim()) {
        const lowerVal = inviteBuilding.toLowerCase();
        const matches = delBuildings.filter(
          (b) =>
            (b.name && b.name.toLowerCase().includes(lowerVal)) ||
            (b.address && b.address.toLowerCase().includes(lowerVal))
        );
        setFilteredBuildings(matches);
      } else {
        // no typed text => show all
        setFilteredBuildings(delBuildings);
      }
      setShowDropdown(true);
    };
  

  // Joyride callback
  const handleShowTour = () => {
    localStorage.setItem('hasSeenRegionalTour', 'false');
    setRunTour(true);
  };
  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if (status === 'finished' || status === 'skipped') {
      localStorage.setItem('hasSeenRegionalTour', 'true');
      setRunTour(false);
    }
  };

// 10) Fetch data once (including a quick refresh of the userObj from the server)
useEffect(() => {
  if (isFetched) return;

  const doFetch = async () => {
    try {
      // 1) Refresh the user from the server
      const userResp = await fetch(`${API_BASE_URL}/api/getUser`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (userResp.ok) {
        const freshUser = await userResp.json();
        // Compare to the local copy
        const oldUserStr = localStorage.getItem("managerUser") || "";
        const newUserStr = JSON.stringify(freshUser);
        if (newUserStr !== oldUserStr) {
          // Overwrite localStorage and re-parse
          console.log("Refreshed user data from server. LocalStorage updated.");
          localStorage.setItem("managerUser", newUserStr);
        }
      } else {
        console.warn("Could not refresh user from server:", userResp.status);
      }

      // 2) Re-parse userObj from localStorage in case it changed
      const updatedUserStr = localStorage.getItem("managerUser") || "";
      let updatedUser = null;
      try {
        updatedUser = JSON.parse(updatedUserStr);
      } catch (err) {
        console.error("Error re-parsing managerUser after refresh:", err);
      }

      if (!updatedUser || !updatedUser.buildings) {
        console.warn("No user or buildings found, skipping fetch");
        setIsLoading(false);
        setIsFetched(true);
        return;
      }

      // 3) Fetch Regional Stats
      const statsRes = await fetch(
        `${API_BASE_URL}/api/getRegionalStats`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ buildings: updatedUser.buildings }),
        }
      );
      if (!statsRes.ok) {
        throw new Error(`Error fetching regional stats: ${statsRes.status}`);
      }
      const statsData = await statsRes.json();
      setStats((prev) => ({
        ...prev,
        completedMaintenances: statsData.completedMaintenances || 0,
      }));

      // 4) Fetch Building details
      const bRes = await fetch(
        `${API_BASE_URL}/api/getRegionalBuildingsDetailedNew`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ buildings: updatedUser.buildings }),
        }
      );
      if (!bRes.ok) {
        throw new Error(`Error fetching building list: ${bRes.status}`);
      }
      const buildingsList = await bRes.json();
      setBuildingsData(buildingsList);

    } catch (err) {
      console.error("Error in fetchData for regional stats/buildings:", err);
    } finally {
      setIsLoading(false);
      setIsFetched(true);
    }
  };

  doFetch();
}, [token, isFetched]);


  // If loading => show spinner
  if (isLoading) {
    return (
      <>
        <Joyride
          steps={steps}
          run={runTour}
          continuous
          showSkipButton
          disableBeacon
          callback={handleJoyrideCallback}
          locale={{
            back: 'Back',
            close: 'Close',
            last: 'Done',
            next: 'Next',
            skip: 'Skip',
          }}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: '#224982',
            },
          }}
        />
        <Navbar isRegional />
        <Header isRegional />
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Spinner animation="border" role="status" />
          <p>Loading dashboard data...</p>
        </div>
        <Footer />
      </>
    );
  }

  // 12) Filter logic
  const filteredData = buildingsData.filter((b) => {
    const s = searchTerm.toLowerCase();
    const nameMatch = b.name?.toLowerCase().includes(s);
    const managerMatch = b.manager?.toLowerCase().includes(s);
    let systemPass = true;
    if (selectedSystems.length > 0) {
      systemPass =
        b.system &&
        b.system.some((sys) => selectedSystems.includes(sys.toLowerCase()));
    }
    return (nameMatch || managerMatch) && systemPass;
  });

  // 13) Sorting & pagination
  function handleSort(columnKey) {
    if (sortColumn === columnKey) {
      setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(columnKey);
      setSortDirection('asc');
    }
    setCurrentPage(1);
  }
  
  const sortedData = [...filteredData].sort((a, b) => {
    // 1) If one has justInvited = true, put it first
    if (a.justInvited && !b.justInvited) return -1;
    if (b.justInvited && !a.justInvited) return 1;
  
    // 2) We'll only do subPriority if user is sorting by 'name' or 'mostRecentMaintenance'
    const useSubPriority = (sortColumn === 'name' || sortColumn === 'mostRecentMaintenance');
  
    if (useSubPriority) {
      // subPriorities for non-invited:
      //   active + finalReport => 1
      //   active + no finalReport => 2
      //   pending => 3
      //   everything else => 999
      const getSubPriority = (bldg) => {
        if (bldg.status === 'Active') {
          return bldg.finalReport ? 1 : 2;
        } else if (bldg.status === 'Pending') {
          return 3;
        }
        return 999;
      };
  
      const aSub = getSubPriority(a);
      const bSub = getSubPriority(b);
      if (aSub !== bSub) {
        return aSub - bSub;
      }
    }
  
    // 3) If subPriority is not in use or equal, do normal column-based compare
  
    // Special case: "mostRecentMaintenance" => parse as date
    if (sortColumn === 'mostRecentMaintenance') {
      const dateA = Date.parse(a[sortColumn]) || 0;
      const dateB = Date.parse(b[sortColumn]) || 0;
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    }
  
    // Special case: "units" => parse as number
    let valA = a[sortColumn];
    let valB = b[sortColumn];
    if (sortColumn === 'units') {
      valA = parseInt(valA, 10) || 0;
      valB = parseInt(valB, 10) || 0;
    } else {
      // Normal case: convert string to lower
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
    }
  
    if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
    if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const pageData = sortedData.slice(startIndex, endIndex);

  function handlePrevPage() {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  }
  function handleNextPage() {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  }
  function handleRowsPerPageChange(e) {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  }

  // Slideshow handlers
  function handleOpenCarousel(photos, index) {
    setCarouselPhotos(photos);
    setCarouselIndex(index);
    setShowModal(true);
  }
  function handleCloseModal() {
    setShowModal(false);
  }
  function handleSelectCarousel(selectedIndex) {
    setCarouselIndex(selectedIndex);
  }

  // buildingPhotos for the Team Management pill
  const buildingPhotos = buildingsData
  .map((b) => b.photo_url || (b.photo && b.photo.url))
  .filter((url) => !!url)
  .slice(0, 6);


  // Create a new array "allItems" with photo + name
  const allItems = buildingsData
  .map((b) => ({
    photo: b.photo_url || (b.photo && b.photo.url),
    name: b.name || "Unknown Building",
  }))
  .filter((item) => !!item.photo);

// Set maximum visible circles (e.g., 5)
const maxVisible = 5;
const visibleItems = allItems.slice(0, maxVisible);
const hiddenItems = allItems.slice(maxVisible);
const hiddenCount = hiddenItems.length;



  // Invite manager modal
  function handleShowInvite() {
    const hasSeenPopup = localStorage.getItem('hasSeenFirstInvitePopup');
    if (!hasSeenPopup) {
      // First time => show the explanation modal
      setShowFirstTimeModal(true);
    } else {
      // Already seen => show the normal invite modal
      setShowInviteModal(true);
    }
  }
  
  function handleCloseFirstTimeModal() {
    // Mark so we never show it again
    localStorage.setItem('hasSeenFirstInvitePopup', 'true');
    setShowFirstTimeModal(false);
  
    // Immediately open the real Invite Manager modal
    setShowInviteModal(true);
  }

  const handleCloseInvite = () => {
    setShowInviteModal(false);
    setInviteName('');
    setInviteEmail('');
    setInviteBuilding('');
  };

  // Send the invite => create row => show in table
  async function handleSendInvite(e) {
    e.preventDefault();
    setInviteLoading(true);
    try {
      // If no selected building, use a placeholder image
     const placeholderUrl = 'https://parsefiles.back4app.com/JPeNcGnGVRxgfjR3k0WTs3fbP6Vu4AagMGFXanwd/32157fda3d1571115589a032769e6c43_building_placeholder.png';
  
      const payload = {
        managerName: inviteName,
        managerEmail: inviteEmail,
        buildingAddress: inviteBuilding,
        regionalName: userObj.first_name || 'Regional Manager',
        regionalEmail: userObj.email || 'service@hudsonhvac.ca',
        managementCompany: userObj.management_company || '',
       buildingPhotoUrl: selectedBuilding 
         ? selectedBuilding.photoUrl 
         : placeholderUrl
      };
  
      console.log("manager payload: ", payload);
  
      const response = await fetch(
        `${API_BASE_URL}/api/invite-manager`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
  
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
  
      const data = await response.json();
      const { newBuilding, updatedBuildings } = data;
  
      // Immediately add the new building row to your local table data
      newBuilding.justInvited = true;
      setBuildingsData((prev) => [...prev, newBuilding]);
  
      // Update the userObj in localStorage with the new building IDs
      userObj.buildings = updatedBuildings;
      localStorage.setItem('managerUser', JSON.stringify(userObj));
  
      // Close modal + show success alert
      handleCloseInvite();
      setShowInviteSuccess(true);
      setTimeout(() => setShowInviteSuccess(false), 3000);
  
    } catch (err) {
      console.error('Error sending invite:', err);
      alert('Error sending invite: ' + err.message);
    } finally {
      setInviteLoading(false);
    }
  }
  
  

  return (
    <>
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        showSkipButton
        disableBeacon
        callback={handleJoyrideCallback}
        locale={{
          back: 'Back',
          close: 'Close',
          last: 'Done',
          next: 'Next',
          skip: 'Skip',
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: '#224982',
          },
        }}
      />

      {showInviteSuccess && (
        <Alert
          variant="success"
          style={{
            position: 'fixed',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            margin: 0,
            padding: '0.5rem 1rem',
          }}
        >
          <strong>Invitation sent successfully!</strong>
        </Alert>
      )}

      <Navbar data-tour="navbar-info" isRegional userObj={userObj} onShowTour={handleShowTour} />
      <Header isRegional />

      {/* Stats (pills) */}
      <div 
        data-tour="pills-stats" 
        style={{ 
          width: '90%',
          margin: '30px auto 2rem',
        }}
      >
        <Row className="g-3">
          <Col xs={12} sm={4}>
            <Card
              data-tour="team-management-pill"
              className="shadow-sm border-0 single-pill-card"
              style={{ height: '100%' }}
            >
              <Card.Body className="single-pill-body" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="single-pill-icon" style={{ color: '#007bff' }}>
                  <FaUsers />
                </div>
                <Card.Title className="single-pill-title" style={{ marginBottom: '1rem' }}>
                  Team Management
                </Card.Title>

                {/* Circles row */}
                <div style={{ position: 'relative', height: '50px', marginBottom: '0.75rem' }}>
                  {/* Render visible building circles with tooltips */}
                  {visibleItems.map((item, idx) => (
                    <OverlayTrigger
                      key={`visible-${idx}`}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-visible-${idx}`}>
                          {item.name}
                        </Tooltip>
                      }
                    >
                      <img
                        src={item.photo}
                        alt={item.name}
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '2px solid #fff',
                          position: 'absolute',
                          left: `${idx * 35}px`,
                          cursor: 'pointer',
                        }}
                      />
                    </OverlayTrigger>
                  ))}

                  {/* Render final blue circle */}
                  {hiddenCount > 0 ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-hidden">
                          <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                            {hiddenItems.map((item, idx) => (
                              <li key={idx} style={{ lineHeight: '1.2' }}>
                                {item.name}
                              </li>
                            ))}
                          </ul>
                        </Tooltip>
                      }
                    >
                      <div
                        style={{
                          position: 'absolute',
                          left: `${visibleItems.length * 35}px`,
                          width: '50px',
                          height: '50px',
                          borderRadius: '50%',
                          backgroundColor: '#007bff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#fff',
                          fontWeight: '600',
                          border: '2px solid #fff',
                          cursor: 'pointer',
                        }}
                      >
                        +{hiddenCount}
                      </div>
                    </OverlayTrigger>
                  ) : (
                    <div
                      style={{
                        position: 'absolute',
                        left: `${visibleItems.length * 35}px`,
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: '600',
                        border: '2px solid #fff',
                      }}
                    >
                      +
                    </div>
                  )}
                </div>

                <div style={{ marginTop: 'auto' }}>
                  <Button
                    className="btn-invite-manager"
                    size="sm"
                    onClick={handleShowInvite}
                  >
                    + Invite Manager
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={4}>
            <SinglePill
              title="Number of Buildings"
              value={stats.numBuildings}
              Icon={FaBuilding}
              iconColor="#007bff"
              circleColor="#007bff"
            />
          </Col>

          <Col xs={12} sm={4}>
            <SinglePill
              title="Completed Maintenances"
              value={stats.completedMaintenances}
              Icon={FaCheckSquare}
              iconColor="#28a745"
              circleColor="#28a745"
            />
          </Col>
        </Row>
      </div>

      {/* Search + Filter */}
      <div style={{
        width: '90%',
        margin: '1rem auto',
        display: 'flex',
        gap: '1rem',
        alignItems: 'center'
      }}>
        <div style={{ flex: '2 1 auto' }}>
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder="Search by Building or Manager"
          />
        </div>
        <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
          <SystemMultiSelect
            selectedSystems={selectedSystems}
            setSelectedSystems={setSelectedSystems}
          />
        </div>
      </div>

      {/* Buildings Table */}
      <div data-tour="buildings-table" style={{ width: '100%', margin: '0 auto 2rem' }}>
        <BuildingsTable
          pageData={pageData}
          sortedData={sortedData}
          startIndex={startIndex}
          endIndex={endIndex}
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          handleSort={handleSort}
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
          handleRowsPerPageChange={handleRowsPerPageChange}
          showModal={showModal}
          carouselPhotos={carouselPhotos}
          carouselIndex={carouselIndex}
          handleOpenCarousel={handleOpenCarousel}
          handleCloseModal={handleCloseModal}
          handleSelectCarousel={handleSelectCarousel}
          isVideoUrl={isVideoUrl}
          handleShowInvite={handleShowInvite}
        />
      </div>

      {/* Invite Manager Modal */}
      <Modal
        show={showInviteModal}
        onHide={handleCloseInvite}
        centered
        dialogClassName="invite-modal-dialog"
        contentClassName="invite-modal-content"
      >
        <div className="inv-card">
          <div className="mb-3">
            <img
              src="https://hudsonhvac.ca/images/logo.png"
              alt="Hudson Logo"
              style={{ maxWidth: '100px', marginBottom: '1rem' }}
            />
          </div>

          <h2
            style={{
              fontSize: '2rem',
              fontWeight: 600,
              marginBottom: '1rem',
              color: '#000'
            }}
          >
            Invite Manager
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              marginBottom: '2rem',
              color: '#6c757d',
              fontWeight: 200,
            }}
          >
            Add your manager's information below, and we'll send them an invitation to join Hudson
          </p>
        </div>

        <Modal.Body>
          <Form onSubmit={handleSendInvite} className="invite-modal-form">
            <Form.Group className="mb-4" controlId="inviteName">
              <Form.Label>
                Manager's Full Name <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter full name"
                value={inviteName}
                onChange={(e) => setInviteName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="inviteEmail">
              <Form.Label>
                Manager's Email Address <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="manager@example.com"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4 position-relative" controlId="inviteBuilding">
            <Form.Label>
              Building Address <span style={{ color: 'red' }}>*</span>
            </Form.Label>

            {/* Wrapper so the image appears inside the input */}
            <div style={{ position: 'relative' }}>
              {/* If a building is selected, show its photo inside the input */}
              {selectedBuilding && selectedBuilding.photoUrl && (
                <img
                  src={selectedBuilding.photoUrl}
                  alt="Selected Building"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '8px',
                    transform: 'translateY(-50%)',
                    width: '32px',
                    height: '32px',
                    borderRadius: '6px',
                    objectFit: 'cover',
                    pointerEvents: 'none'
                  }}
                />
              )}

              {/* The actual text input, with extra left padding if an image is shown */}
              <Form.Control
                type="text"
                placeholder="Enter building address"
                value={inviteBuilding}
                onChange={handleBuildingChange}
                required
                style={{
                  paddingLeft: selectedBuilding && selectedBuilding.photoUrl ? '50px' : '12px',
                  paddingRight: '30px' // room for the chevron
                }}
              />

              {/* Chevron icon for toggling the dropdown */}
              <FaChevronDown
                onClick={handleToggleDropdown}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '8px',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#888'
                }}
              />
            </div>

            {/* Dropdown menu below the input */}
            {showDropdown && (
              <div
                style={{
                  position: 'absolute',
                  zIndex: 1000,
                  width: '100%',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  background: '#fff',
                  border: '1px solid #ccc',
                  marginTop: '2px'
                }}
              >
                {filteredBuildings.map((b, idx) => (
                  <div
                    key={`${b.address}-${idx}`}
                    className="building-option"
                    onClick={() => {
                      setInviteBuilding(b.address);
                      setSelectedBuilding(b);
                      setShowDropdown(false);
                    }}
                  >
                    {b.photoUrl && <img src={b.photoUrl} alt={b.name} />}
                    <span>{b.address}</span>
                  </div>
                ))}
              </div>
            )}
          </Form.Group>


            <Button
              type="submit"
              className="invite-submit-btn"
              disabled={inviteLoading}
              style={{ width: '100%' }}
            >
              {inviteLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: '0.5rem' }}
                  />
                  Sending...
                </>
              ) : (
                'Send Invitation'
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>


      {/* First-Time Explanation Modal */}
        <Modal
          show={showFirstTimeModal}
          onHide={handleCloseFirstTimeModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Inviting a Building Manager</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>When you invite a building manager, Hudson will reach out to them directly to prepare a preventive maintenance proposal for their property. The manager will be notified, and Hudson will handle the follow-up.<br /><br />
            Their status in your District dashboard will appear as "Pending" until their Board approves the proposal. Once approved, their status will change to "Active", and you'll receive an email notification.<br /><br />
            Once a building is active, you'll be able to view their maintenance schedules, service reports, and more—right from your dashboard.
              </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCloseFirstTimeModal}>
              Got it
            </Button>
          </Modal.Footer>
        </Modal>



      <Footer data-tour="footer-support" />
    </>
  );
}

export default RegionalDashboard;

